import { Link } from "react-router-dom";
import { ArrowRight, Info, AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function HelpToBuyPage() {
  return (
    <div data-testid="help-to-buy-page">
      <section className="relative bg-[#111111] py-32 lg:py-40">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1920&q=80')] bg-cover bg-center opacity-15" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[#d64241] font-semibold text-sm tracking-widest uppercase mb-3 font-body">Special Schemes</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight">
            Help to<br /><span className="text-[#d64241]">Buy</span>
          </h1>
        </div>
      </section>

      <section data-testid="help-to-buy-content" className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            <div>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8 font-body">
                At <strong className="text-black">KK Mortgage Solutions</strong>, we understand that navigating the next steps can be overwhelming. Whether you're managing your existing equity loan or exploring new financing options, our team is here to guide you.
              </p>

              <div className="bg-[#fef2f2] border border-[#f4adad] rounded-xl p-6 mb-8">
                <div className="flex items-start gap-3">
                  <AlertCircle className="w-5 h-5 text-[#d64241] flex-shrink-0 mt-0.5" />
                  <div>
                    <h3 className="font-semibold text-black mb-2">Help to Buy: Equity Loan has closed</h3>
                    <ul className="text-sm text-gray-600 font-body space-y-2">
                      <li>You can find more information about Help to Buy: Equity Loan (2013-2021) in our homebuyers' guide.</li>
                      <li>For information on how to manage your equity loan, visit Manage your Help to Buy: Equity Loan.</li>
                    </ul>
                  </div>
                </div>
              </div>

              <h2 className="text-2xl md:text-3xl font-semibold text-black tracking-tight mb-4">Overview</h2>
              <div className="space-y-4 mb-8">
                <div className="flex gap-3">
                  <Info className="w-5 h-5 text-[#d64241] flex-shrink-0 mt-1" />
                  <p className="text-gray-600 font-body leading-relaxed text-sm">Help to Buy: Equity Loan (2013-2021) was a scheme for first-time buyers. It included regional property price limits to ensure the scheme reached people who needed it most.</p>
                </div>
                <div className="flex gap-3">
                  <Info className="w-5 h-5 text-[#d64241] flex-shrink-0 mt-1" />
                  <p className="text-gray-600 font-body leading-relaxed text-sm">Homebuyers could borrow between 5% and 20% of the cost of a newly built home in England, and up to 40% in London.</p>
                </div>
                <div className="flex gap-3">
                  <Info className="w-5 h-5 text-[#d64241] flex-shrink-0 mt-1" />
                  <p className="text-gray-600 font-body leading-relaxed text-sm">Help to Buy: Equity Loan (2013-2021) was launched on 1 April 2013.</p>
                </div>
              </div>

              <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8 font-body font-medium">
                Even though it's closed, KKMS can help if you have a Help to Buy loan. Contact us to discuss your options.
              </p>

              <Link to="/contact">
                <Button data-testid="help-to-buy-cta-btn" className="bg-[#d64241] hover:bg-[#b53736] text-white rounded-full px-8 py-6 text-base font-semibold shadow-lg shadow-[#d64241]/25 hover:-translate-y-0.5 transition-all duration-200">
                  Get Expert Advice <ArrowRight className="w-4 h-4 ml-1" />
                </Button>
              </Link>
            </div>
            <div>
              <div className="rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.1)]">
                <img src="https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?w=800&q=80" alt="Help to Buy" className="w-full h-[400px] lg:h-[550px] object-cover" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
